<template>
    <v-app>
        <v-navigation-drawer v-model="sidebar" app>
            <v-list>
                <div v-for="item in menuItems" :key="item.title">
                    <v-list-tile
                            :to="item.path"
                            v-if="item.login === isLogin">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>{{ item.title }}</v-list-tile-content>
                    </v-list-tile>
                </div>
            </v-list>
        </v-navigation-drawer>

        <v-toolbar app>
            <span class="hidden-sm-and-up">
                <v-toolbar-side-icon @click="sidebar = !sidebar">
                </v-toolbar-side-icon>
            </span>
            <v-toolbar-title>
                <router-link to="/" tag="span" style="cursor: pointer">
                    {{ this.$store.state.appTitle }}
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-xs-only">
                <template v-for="item in menuItems">
                    <v-btn
                            flat
                            :key="item.title"
                            :to="item.path"
                            v-if="item.login === isLogin">
                        <v-icon left dark>{{ item.icon }}</v-icon>
                        {{ item.title }}
                    </v-btn>
                </template>
                <v-btn @click="changeLang('en')">English</v-btn>
                <v-btn @click="changeLang('es')">Español</v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
    import DeviceService from "./apiServices/DeviceService";

    export default {
        data () {
            return {
                isLogin: this.$store.getters.isLogin,
                sidebar: false,
                menuItems: this._getMenuItems(),
                langs: ['en', 'es'],
            }
        },
        created: function () {
            this.$axios.interceptors.response.use(undefined, function (err) {
                // eslint-disable-next-line no-unused-vars
                return new Promise(function (resolve, reject) {
                    if (err.status === 401) {
                        this.$store.dispatch('logout')
                    }
                    throw err
                });
            });

            window.$messaging.onMessage(this.onMessage)
            window.$messaging.onTokenRefresh(this.onTokenRefresh)
            this.onTokenRefresh()
        },
        methods:{
            _getMenuItems(){
                return [
                    { title: this.$t('dashboard_menu_btn_message'), path: '/dashboard', icon: 'home', login: true },
                    { title: this.$t('me_menu_btn_message'), path: '/me', icon: 'perm_identity', login:true},
                    { title: this.$t('new_publication_menu_btn_message'), path:'/publish', icon:'add_alert', login:true},
                    { title: this.$t('new_subscription_menu_btn_message'), path:'/subscribe', icon:'person_add', login:true},
                    { title: this.$t('register_menu_btn_message'), path: '/register', login: false}
                ]
            },
            changeLang(lang){
                localStorage.setItem('lang', lang)
                this.$root.$i18n.locale = lang
            },
            onMessage(payload){
                window.console.log("Message received. ", JSON.stringify(payload))
                let notification = new Notification(payload.data.title, window.generateNotificationData(payload.data))
                notification.onclick = window.onClickNotification
            },
            onTokenRefresh(){
                let self = this;
                window.$messaging.getToken()
                    .then(function (refreshedToken) {
                        if(!self.$store.getters.isLogin) return;
                        DeviceService.updateToken(refreshedToken)
                        window.console.log('Token refreshed.')
                    }).catch(function (err) {
                        window.console.log('Unable to retrieve refreshed token ', err)
                    });
            }
        }
    }
</script>

<i18n>
    {
        "en": {
            "dashboard_menu_btn_message": "Dashboard",
            "me_menu_btn_message": "Me",
            "new_publication_menu_btn_message": "New Publication",
            "new_subscription_menu_btn_message": "New Subscription",
            "register_menu_btn_message": "Register"
        },
        "es": {
            "dashboard_menu_btn_message": "Dashboard",
            "me_menu_btn_message": "Mi Perfil",
            "new_publication_menu_btn_message": "Nueva Publicación",
            "new_subscription_menu_btn_message": "Nueva suscripción",
            "register_menu_btn_message": "Registrar"
        }
    }
</i18n>